import { SelectBoxMulti } from '@core/components/SelectBoxMulti/SelectBoxMulti';
import {
  photosState,
  possibleClassifications,
  setSelectedClassifications,
} from '@photos/components/PhotosInViewport/state';
import { useSnapshot } from 'valtio';

export const PhotosClassifications = () => {
  const { showPhotos, selectedClassifications } = useSnapshot(photosState);

  return (
    <SelectBoxMulti
      label="Photo classification"
      availableItems={[...possibleClassifications]}
      items={selectedClassifications}
      setItems={setSelectedClassifications}
      disabled={!showPhotos}
    />
  );
};
